import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { useSnowplowContext } from "supercell-frontend-base/src/analytics/snowplow";

import { filterLiveArticles } from "supercell-frontend-base/src/utils/targeting/filter-live-articles";

import { CommunityView } from "./view";

export const CommunityController = () => {
    const { pathname: pagePath } = useLocation();
    const { trackPageView } = useSnowplowContext();

    useEffect(() => {
        trackPageView("Community", pagePath);

        window.history.pushState({ home: true }, undefined);
    }, []);

    return <CommunityView filterArticles={filterLiveArticles} />;
};
